import FirebaseContext, { withFirebase } from './context';
import firebase from './firebase';

export default firebase;

export { FirebaseContext, withFirebase };
